import {getCookie, ajax, formSave, extend, setCookie} from '../../_helpers'
import show from '../modules/success'
// const fileDownload = require('js-file-download')

const conf = {
    action: '/form',
    cookie_data_name: 'form_data',
    css_clases: {
        formBeforeSubmit: 'wait',
        formHasError: 'has-error',
    }
}

class AjaxForm {
    constructor(form) {
        let _this = this;

        this.form = form;
        this.id = this.form.getAttribute('data-name');

        this.fields = this.form.querySelectorAll('[name][type=\"text\"]:not([disabled]), [name][type=\"hidden\"], [name][type=\"number\"]:not([disabled]), [name][type=\"checkbox\"]:checked:not([disabled]), [name][type=\"radio\"]:checked:not([disabled]), textarea[name]:not([disabled])')

        this.labels_default = {};

        let labels_default = {};

        Array.prototype.forEach.call(this.form.querySelectorAll('label'), function (label) {
            labels_default[label.getAttribute('for')] = label.innerHTML;
        })

        this.labels_default = labels_default;

        this.submit_btn = this.form.querySelector('[type=submit]');
        this.data = {};
        this.params = {};
        this.close_modal = this.form.getAttribute('data-close-modal') ? this.form.getAttribute('data-close-modal') : null;

        //listners
        this.submit_btn.addEventListener('click', ev => this.submit(ev))

        //fill form cookie
        this.restoreForm();
    }

    submit(ev) {
        if(this.submit_btn.classList.contains('load')) return false

        this.actualData();

        this.send();
    }

    send() {
        this.beforeSuccess()
        ajax(conf.action, this.data, (json) => this.success(json))
    }

    beforeSuccess() {
        if(this.form.querySelector('.wait_box')){
            this.form.classList.add(conf.css_clases.formBeforeSubmit);
        }else{
            this.submit_btn.classList.add('load')
        }
    }

    success(result) {
        this.form.classList.remove(conf.css_clases.formBeforeSubmit);

        if(!this.form.querySelector('.wait_box')){
            this.submit_btn.classList.remove('load')
        }

        this.saveForm(); //save form data to cookie

        let labels_default = this.labels_default;

        Array.prototype.forEach.call(this.form.querySelectorAll('.input_box'), function (input_box) {
            let input = input_box.querySelector('[name]'),
                name = input.getAttribute('name'),
                box = input.parentElement,
                label = box.querySelector('label'),
                default_msg = labels_default[label.getAttribute('for')];

            if (result.errors && result.errors[name]) {
                let msg = result.errors[name][0]
                box.classList.add('haserror')
                label.innerHTML = msg
            } else {
                box.classList.remove('haserror')
                label.innerHTML = default_msg
            }
        })

        if(result.success){
            let title = result.success[0] ? result.success[0] : null;
            let body = result.success[1] ? result.success[1] : null;
            show( this.close_modal ?  document.getElementById(this.close_modal) : null, title, body);

            if(typeof ga !== 'undefined') ga("send", "event", "thankYouPage", "load", "lead")

            if(yaCounterId !== undefined && yaCounterId != null) {
                window['yaCounter'+yaCounterId].reachGoal("order")
            }else{
                console.log('yaCounter target failure!')
            }
        }

        if(result.getjournal){
            var journal = document.querySelector('.journal');
            if(journal){
                journal.classList.remove('show')
            }
        }

        if(result.file){
            // fileDownload(result.file[0], result.file[1]);
            downloadFile(result.file[0], result.file[1]);
        }

        function downloadFile(response, filename) {
            var link = document.createElement('a')
            link.href = response
            link.download = filename
            link.click()
            setTimeout(function () {
                link.remove()
            }, 100)
        }

    }

    actualData() {
        let data = new FormData();
        let params = {};

        data.append('form', this.id);

        Array.prototype.forEach.call(this.fields, function (field) {
            data.append(field.getAttribute('name'), field.value)
            params[field.getAttribute('name')] = field.value
        })

        //add page name
        var page_category_name = document.querySelector('meta[name="page-category-name"]')
        if(page_category_name){
            data.append('page_category_name', page_category_name.content)
        }

        //add meta
        var adv = document.querySelector('meta[name="adv"]'),
            form_page = document.querySelector('meta[name="form_page"]'),
            referer = document.querySelector('meta[name="referer"]')

        if(adv) data.append('adv', adv.content)
        if(form_page) data.append('form_page', form_page.content)
        if(referer) data.append('referer', referer.content)

        this.data = data;
        this.params = params;

        console.log(this.params)
    }

    error(result) {
        console.log(result);
    }

    saveForm() {
        formSave(conf.cookie_data_name, this.params);
    }

    restoreForm() {
        let form_data = getCookie(conf.cookie_data_name, '|');

        for (let name in form_data) {
            let val = form_data[name],
                field = this.form.querySelector('[name=\"' + name + '\"]');

            if(field){
                if (field.getAttribute('type') == 'text') {
                    field.parentElement.classList.add('complite')
                    field.value = val;
                }
            }
        }
    }
}

export default function init_ajaxform(selector) {
    const forms = [];

    var selecttor_forms = document.querySelectorAll(selector)

    if(selecttor_forms){
        Array.prototype.forEach.call(selecttor_forms, function (form) {
            forms.push(new AjaxForm(form))
        })
    }

    return forms;
}
